export const RESOURCE_NOT_FOUND_CODE = 'RESOURCE_NOT_FOUND'

export const RESOURCE_NOT_FOUND_MESSAGE = {
  id: 'ENGAGE.RESOURCE_NOT_FOUND',
  defaultMessage:
    'A selected group or user no longer exists in Microsoft 365, so it was not updated. Deleted groups disappear from the list after the next tenant sync.',
}

export const GROUP_UPDATE_FAILED_MESSAGE = {
  id: 'ENGAGE.GROUP_UPDATE_FAILED',
  defaultMessage: 'The groups could not be updated. Please try again.',
}

const toObject = (taskErrors) => {
  if (typeof taskErrors !== 'string') {
    return taskErrors
  }

  try {
    return JSON.parse(taskErrors)
  } catch (error) {
    return null
  }
}

// Group task errors are stored per employee: { [employeeIdentifier]: [error, ...] }
const flattenGroupTaskErrors = (taskErrors) => {
  const parsed = toObject(taskErrors)

  if (Array.isArray(parsed)) {
    return parsed
  }

  if (parsed && typeof parsed === 'object') {
    return Object.values(parsed).flat()
  }

  return []
}

// Only report a missing resource when it is the sole failure, so other failed changes are never hidden
export const getGroupTaskErrorMessage = (taskErrors) => {
  const errors = flattenGroupTaskErrors(taskErrors)
  const onlyMissingResources = errors.length > 0 && errors.every((error) => error?.code === RESOURCE_NOT_FOUND_CODE)

  return onlyMissingResources ? RESOURCE_NOT_FOUND_MESSAGE : GROUP_UPDATE_FAILED_MESSAGE
}
